import { CellContext } from '@tanstack/react-table'
import { RowAction } from '../types-v4'
import { useSubmitForm } from '../../FormComponent/useSubmitForm'
import { useState } from 'react'
import { ConfirmDialog } from '@/components/ui/ConfirmDialog'
import { DynamicIcon } from '@/components/icons/DynamicIcon'
import { InferFormValues, JsonFormSchemaV2 } from '../../FormComponent/types'
import { CATALOG_BASE_PATH } from '@/const'
import { useNavigate, useSearchParams } from 'react-router'

export function ActionWithConfirmDialog<T, V>({ action, info }: { action: RowAction; info: CellContext<T, V> }) {
  const values = info.row.original
  const handlerId = action.handlerId || ''
  const actionId = action.id || ''
  const emptyTileFilterSelections: Record<string, unknown>[] = []
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(false)
  const [searchParams] = useSearchParams()
  const { mutate: submitForm, isPending: isSubmitting } = useSubmitForm(
    handlerId,
    emptyTileFilterSelections,
    actionId,
    {
      onSuccess: () => setIsOpen(false),
    }
  )

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const meta = info.table.options.meta as any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const isGroup = (info.row.original as Record<string, unknown>).isGroup
  const deleteGroup = meta?.deleteGroup

  if (!handlerId) {
    console.error('No handlerId provided for action:', action)
    return null
  }

  const onConfirm = () => {
    if (action.type === 'navigate') {
      navigate(`${CATALOG_BASE_PATH}${handlerId}?${searchParams.toString()}`)
      return
    }

    // Special handling for group rows: delete locally instead of submitting to backend
    if (isGroup && deleteGroup) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      deleteGroup((info.row.original as any).id)
      setIsOpen(false)
      return
    }

    submitForm(values as InferFormValues<JsonFormSchemaV2>)
  }

  return (
    <ConfirmDialog
      trigger={
        <div className="flex items-center gap-2">
          <DynamicIcon
            iconName={action.icon || ''}
            lazyLoad={false}
            className="size-3"
            fallback={<div className="size-4" />}
          />
          <span>{action.label}</span>
        </div>
      }
      isOpen={isOpen}
      onOpenChange={(open) => setIsOpen(open)}
      title={action.label}
      description={action.confirmationMessage}
      onConfirm={onConfirm}
      closeOnConfirm={false}
      isSubmitting={isSubmitting}
    />
  )
}
